module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', [(!_vm.hideDisclaimerButton) ? _c('module-button', {
    class: (_vm.isBurgerClick && _vm.menuActive) ? 'language-mobile' : 'language',
    attrs: {
      "button": "primary",
      "size": "s"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectActionlanguage.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "language__icon"
  }, [_c('img', {
    staticClass: "about__img hide-below-medium",
    attrs: {
      "src": _vm.language,
      "alt": "ALT"
    }
  })]), _vm._v("\n    Language\n  ")]) : _vm._e(), _vm._v(" "), _c('module-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectLanguage),
      expression: "selectLanguage"
    }],
    attrs: {
      "modal": _vm.modalData
    },
    on: {
      "close": _vm.closeDisclaimer
    }
  }, [_c('template', {
    slot: "modal-footer"
  }, [_c('module-button', {
    attrs: {
      "button": "primary",
      "size": "s"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.languageAgreed.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Accept\n        ")]), _vm._v(" "), _c('module-button', {
    attrs: {
      "button": "secondary",
      "size": "s"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancled.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Cancel\n        ")])], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideDisclaimerButton),
      expression: "hideDisclaimerButton"
    }],
    attrs: {
      "id": "google_translate_element_position"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: ['nav-main-row', 'fwc-row', 'a-center'],
    style: ({
      'background': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_c('div', {
    staticClass: "nav-header-list-item"
  }, [_c('span', {
    staticClass: "icon-phone-light"
  }, [_c('img', {
    style: ({
      'fill': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "src": _vm.iconPhoneLight,
      "alt": "Login"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-header-list-desktop"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "nav-header-list-desktop__emergency"
  }, [_c('p', {
    staticClass: "header-text"
  }, [_vm._v("EAP support call/text :")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": ("tel:" + _vm.number)
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.number))])])])])])]), _vm._v(" "), _c('div', {
    style: ({
      'border-top-color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_c('div', {
    staticClass: "header__inner"
  }, [_c('span', {
    class: ['header__toggle', {
      'header__toggle--active': _vm.menuActive
    }],
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "fullHeader": ""
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenu()
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [
      'header__wrapper',
      {
        'header__wrapper--active': _vm.menuActive
      },
      {
        'header__wrapper--full': !_vm.fullHeader
      }
    ]
  }, [_c('div', {
    staticClass: "header__branding"
  }, [_c('router-link', {
    class: [
      'header__logo',
      {
        'header__logo--custom': _vm.org.glyph && _vm.org.glyph.full_size
      }
    ],
    attrs: {
      "to": {
        name: "home"
      }
    }
  }, [(_vm.org.glyph && _vm.org.glyph.full_size) ? _c('img', {
    attrs: {
      "width": ((_vm.org.glyph_width) + "px"),
      "height": ((_vm.org.glyph_height) + "px"),
      "src": _vm.org && _vm.org.glyph && _vm.org.glyph.full_size,
      "alt": _vm.org && _vm.org.program_name
    }
  }) : _c('module-logo')], 1)], 1), _vm._v(" "), _c('div', {
    class: [
      "navigation",
      {
        'navigation--open': _vm.menuActive,
        //'hide-below-medium': fullHeader
      }
    ]
  }, [_c('div', [_c('div', [(_vm.menuActive) ? _c('div', {
    staticClass: "burgerclose"
  }, [_c('button', {
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('img', {
    staticClass: "burgerclose__img ",
    attrs: {
      "src": _vm.xIcon,
      "alt": "Xicon"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: (_vm.isBurgerClick && _vm.menuActive) ? 'activebg' : ''
  }, [_c('ul', {
    staticClass: "navigation__inner",
    attrs: {
      "fullHeader": ""
    }
  }, [(_vm.isAuthenticated) ? _c('router-link', {
    class: ['navigation__item', 'navigation__item--' + 'messages'],
    attrs: {
      "to": {
        name: 'messages'
      },
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuActive = false, _vm.isBurgerClick = false
      }
    }
  }, [_c('a', {
    class: [
      'navigation__link',
      'link link--underline',
      'c-hedlink',
      {
        'router-link-active': 'messages' === _vm.$route.name
      }
    ]
  }, [_c('span', {
    staticClass: "navigation__label",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Messages\n                    "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unreadCount),
      expression: "unreadCount"
    }],
    staticClass: "navigation__count"
  }, [_vm._v("(" + _vm._s(_vm.unreadCount) + ")")])])])]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _c('router-link', {
    class: ['navigation__item', 'navigation__item--' + 'documents'],
    attrs: {
      "to": {
        name: 'documents'
      },
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuActive = false, _vm.isBurgerClick = false
      }
    }
  }, [_c('a', {
    class: [
      'navigation__link',
      'link link--underline',
      'c-hedlink',
      {
        'router-link-active': 'documents' === _vm.$route.name
      }
    ]
  }, [_c('span', {
    staticClass: "navigation__label",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Documents")])])]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _c('router-link', {
    class: ['navigation__item', 'navigation__item--' + 'appointments'],
    attrs: {
      "to": {
        name: 'appointments'
      },
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuActive = false, _vm.isBurgerClick = false
      }
    }
  }, [_c('a', {
    class: [
      'navigation__link',
      'link link--underline',
      'c-hedlink',
      {
        'router-link-active': 'appointments' === _vm.$route.name
      }
    ]
  }, [_c('span', {
    staticClass: "navigation__label",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Appointments")])])]) : _vm._e(), _vm._v(" "), (_vm.org.username !== 'is_root_org') ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAuthenticated),
      expression: "isAuthenticated"
    }],
    staticClass: "header__divider",
    style: ({
      'background': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }) : _vm._e(), _vm._v(" "), (_vm.org && _vm.org.username && _vm.org.username !== 'is_root_org') ? _c('router-link', {
    class: ['navigation__item', 'navigation__item--' + 'about'],
    attrs: {
      "to": {
        name: 'about'
      },
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuActive = false, _vm.isBurgerClick = false
      }
    }
  }, [_c('a', {
    class: [
      'navigation__link',
      'link link--underline',
      {
        'router-link-active': 'about' === _vm.$route.name
      }
    ]
  }, [_c('span', {
    staticClass: "navigation__label, c-accent",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("What's " + _vm._s(_vm.org.program_name || "Carelon Wellbeing") + "?")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.menus), function(route) {
    return _c('router-link', {
      key: route.path,
      class: ['navigation__item', 'navigation__item--' + route.path],
      attrs: {
        "to": {
          name: route.path
        },
        "tag": "li"
      },
      nativeOn: {
        "click": function($event) {
          _vm.menuActive = false, _vm.isBurgerClick = false
        }
      }
    }, [(_vm.org && _vm.org.username) ? _c('a', {
      class: [
        'navigation__link',
        'link link--underline',
        'c-accent',
        {
          'router-link-active': route.path === _vm.$route.name
        }
      ]
    }, [_c('span', {
      staticClass: "navigation__label",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v(_vm._s(route.name))])]) : _vm._e()])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "header__user"
  }, [(_vm.isAuthenticated) ? _c('div', {
    staticClass: "header__fullprofile"
  }, [_c('div', {
    staticClass: "profilepic"
  }, [_c('img', {
    style: ({
      'fill': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "src": _vm.profilePicture,
      "alt": "profilePicture"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Test"
  }, [_c('router-link', {
    class: ['h2', 'profilename', 'navigation__item--profile'],
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "to": {
        name: 'profile'
      },
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuActive = false, _vm.isBurgerClick = false
      }
    }
  }, [_c('a', {
    class: [
      'navigation__link',
      'link link--underline',
      'profile',
      {
        'router-link-active': 'profile' === _vm.$route.name
      }
    ]
  }, [_c('span', {
    staticClass: "navigation__label",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("\n                  " + _vm._s(_vm.firstName) + "\n                ")])])]), _vm._v(" "), (_vm.isAuthenticated) ? _c('router-link', {
    class: [{
      mt0: !_vm.isAuthenticated
    }],
    attrs: {
      "to": '/log-out'
    }
  }, [_c('div', {
    staticClass: "header__logout"
  }, [_c('span', {
    staticClass: "navigation__label navigation__link logoutnav link link--underline",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("\n                  Log out\n                ")]), _c('img', {
    style: ({
      'fill': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "src": _vm.logoutIcon,
      "alt": "Logout"
    }
  })])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.org && _vm.org.username && _vm.org.username !== 'is_root_org') ? [(!_vm.isAuthenticated && !_vm.org.dfd_client) ? _c('router-link', {
    class: ['header__logout', {
      mt0: !_vm.isAuthenticated
    }],
    attrs: {
      "to": '/log-in'
    }
  }, [_c('img', {
    staticClass: "header__login__img",
    style: ({
      'fill': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "src": _vm.loginIcon,
      "alt": "Login"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "navigation__label navigation__link link link--underline",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("\n              Log in\n            ")])]) : _vm._e(), _vm._v(" "), (!_vm.isAuthenticated && _vm.org.dfd_client) ? _c('a', {
    class: ['header__logout', {
      mt0: !_vm.isAuthenticated
    }],
    attrs: {
      "href": ((_vm.sanitizeUrl(_vm.org.dfd_redirect_url)) + "/sign-in?cw=true")
    }
  }, [_c('img', {
    style: ({
      'fill': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "src": _vm.loginIcon,
      "alt": "Login"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "navigation__label navigation__link logoutnav link link--underline",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("\n              Log in\n            ")])]) : _vm._e()] : _vm._e()], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-header-list-desktop__emergency"
  }, [_c('p', {
    staticClass: "header-text"
  }, [_vm._v("Emergency :")]), _vm._v(" "), _c('a', {
    staticClass: "header-num",
    attrs: {
      "href": "tel:911"
    }
  }, [_vm._v("911")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-header-list-desktop__emergency"
  }, [_c('p', {
    staticClass: "header-text"
  }, [_vm._v("Suicide :")]), _vm._v(" "), _c('a', {
    staticClass: "header-num",
    attrs: {
      "href": "tel:988"
    }
  }, [_vm._v("988")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad1ea1b8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Header.vue
// module id = 281
// module chunks = 2